export default __webpack_public_path__ + "static/media/windD3d.91806fe5.png";